import { Modal, ModalComponent } from "@customer-app/account/views/OperationAquarius/GlobalModal";
import { CustomerSubReducer } from "@customer-app/state/typedCustomerRedux";

import { IModalOptions } from "../actionCreators/modal";

export interface IModalReducerState<T extends ModalComponent = any> {
  activeComponent: T | null;
  activeComponentProps: Modal<T> | null;
  options?: IModalOptions;
}

const initialState: IModalReducerState = {
  activeComponent: null,
  activeComponentProps: null,
  options: {},
};

export const modalReducer: CustomerSubReducer<IModalReducerState> = (state = initialState, action) => {
  switch (action.type) {
    case "OPEN_MODAL": {
      return {
        activeComponent: action.payload.component,
        activeComponentProps: action.payload.props,
        options: action.payload.options,
      };
    }
    default: {
      return state;
    }
  }
};
